import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-error-outline-icon',
  template: `
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33203 9.99967H8.66536V11.333H7.33203V9.99967ZM7.33203 4.66634H8.66536V8.66634H7.33203V4.66634ZM7.99203 1.33301C4.31203 1.33301 1.33203 4.31967 1.33203 7.99967C1.33203 11.6797 4.31203 14.6663 7.99203 14.6663C11.6787 14.6663 14.6654 11.6797 14.6654 7.99967C14.6654 4.31967 11.6787 1.33301 7.99203 1.33301ZM7.9987 13.333C5.05203 13.333 2.66536 10.9463 2.66536 7.99967C2.66536 5.05301 5.05203 2.66634 7.9987 2.66634C10.9454 2.66634 13.332 5.05301 13.332 7.99967C13.332 10.9463 10.9454 13.333 7.9987 13.333Z"
        fill="#323232"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorOutlineIconComponent {}
